import React, { useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import "../../css/faqs.css";

const faqsData = [
  {
    question: "How do I start a PCD Pharma Franchise with Chemo Biological Limited?",
    answer: <>Starting your PCD Pharma Franchise is simple. Submit our inquiry form or contact our team. After checking <strong>territory availability</strong>, we’ll guide you through the required <strong>GST Registration and Drug License</strong> documentation. Once approved, you can place your first order and begin your franchise journey with our complete business support.</>
  },
  {
    question: "Do you provide monopoly rights for the PCD Pharma Franchise?",
    answer: <>Yes. <strong>Chemo Biological Limited</strong> provides <strong>exclusive monopoly rights</strong> to eligible franchise partners for their selected territory and product range. This helps partners build their market without direct competition from another Chemo Biological franchise partner in the same assigned territory.</>
  },
  {
    question: "What marketing support do you provide to franchise partners?",
    answer: <>We provide comprehensive <strong>free promotional and marketing support</strong>, including product cards, visual aids, promotional bags, branded stationery, product samples, LBLs, promotional gifts, and digital marketing materials, helping our partners promote products effectively.</>
  },
  {
    question: "What pharmaceutical products are available for the PCD Pharma Franchise?",
    answer: <>Chemo Biological Limited offers a <strong>wide range of quality pharmaceutical products</strong> across multiple therapeutic segments, including <strong>Derma, Gynae, Ortho, General Range, and other healthcare categories</strong>, giving franchise partners multiple opportunities to expand their product portfolio.</>
  },
  {
    question: "Why choose Chemo Biological Limited for a PCD Pharma Franchise?",
    answer: <>With <strong>43+ years of experience</strong>, Chemo Biological Limited focuses on quality, reliability, and partner growth. We offer <strong>500+ pharmaceutical products, monopoly franchise opportunities, marketing support, and dedicated business assistance</strong>, making us a trusted choice for a <strong>PCD Pharma Franchise in India</strong>.</>
  }
];

function Faqs({ setShowModal }) {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-3 py-lg-5" style={{ backgroundColor: "#fdfdfd" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h6 className="fw-bold text-uppercase mb-2" style={{ color: "#e86229", letterSpacing: "2px" }}>FAQ</h6>
          <h2 className="fw-bold display-6" style={{ color: "#1a2f55" }}>Frequently Asked Questions</h2>
          <div style={{ width: "60px", height: "4px", backgroundColor: "#e86229", margin: "15px auto", borderRadius: "2px" }}></div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="faq-container">
              {faqsData.map((faq, index) => (
                <div 
                  key={index} 
                  className={`faq-item bg-white mb-3 rounded-4 shadow-sm border border-light overflow-hidden ${activeIndex === index ? 'active' : ''}`}
                >
                  <button 
                    className="faq-button w-100 text-start px-4 py-3 border-0 bg-transparent d-flex justify-content-between align-items-center"
                    onClick={() => toggleFaq(index)}
                  >
                    <span className="fw-bold" style={{ color: activeIndex === index ? "#e86229" : "#1a2f55", fontSize: "16px" }}>
                      {faq.question}
                    </span>
                    <span className="faq-icon ms-3" style={{ color: activeIndex === index ? "#e86229" : "#1a2f55" }}>
                      {activeIndex === index ? <FaMinus size={14} /> : <FaPlus size={14} />}
                    </span>
                  </button>
                  
                  <div 
                    className="faq-answer px-4" 
                    style={{ 
                      maxHeight: activeIndex === index ? "500px" : "0", 
                      opacity: activeIndex === index ? 1 : 0,
                      paddingBottom: activeIndex === index ? "20px" : "0",
                      transition: "all 0.3s ease-in-out",
                      overflow: "hidden" 
                    }}
                  >
                    <p className="text-muted mb-0" style={{ lineHeight: "1.7", fontSize: "15px" }}>
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mt-5">
          <button className="btn px-4 py-3 text-white fw-bold shadow-sm rounded-pill" style={{ backgroundColor: "#1a2f55" }} onClick={() => setShowModal(true)}>
            Still have questions? Ask an Expert
          </button>
        </div>
      </div>
    </section>
  );
}

export default Faqs;
